import React from 'react';
import { Check } from 'lucide-react';

const AboutSection = ({ data }) => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="about-grid">
          <div className="about-image-wrapper">
            <img 
              src={data.image} 
              alt="Dr. Subhashini G"
              className="about-image"
            />
          </div>

          <div className="about-content">
            <div className="section-label">About Me</div>
            <h2 className="section-heading">{data.title}</h2>
            
            <p className="about-description">
              {data.description}
            </p>

            <div className="about-highlights">
              {data.highlights.map((highlight, index) => (
                <div key={index} className="highlight-item">
                  <div className="highlight-icon">
                    <Check size={20} />
                  </div>
                  <span className="highlight-text">{highlight}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
